module.exports = __webpack_public_path__ + "static/img/iconfont.eec6a1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/iconfont.svg?v=1.0.0
// module id = aIzy
// module chunks = 34